<script setup lang="ts">
import { ProductPromotion } from '~/lib/services/store/common.dto'

const { userSegmentation } = useProductPromos()

const { big = false, promotions } = defineProps<{
  big?: boolean
  promotions: ProductPromotion[]
}>()

const validPromo = computed(() => validPromoForBubble(promotions, userSegmentation.value))

const displayText = computed(() => {
  if (!validPromo.value) return
  return getPromoLabel(validPromo.value)
})
</script>

<template>
  <div
    v-if="validPromo"
    class="flex w-fit flex-row gap-2 rounded-xl bg-mcd-tertiaryGreenDisabled px-2 py-[2px]"
    :class="{ 'py-[4px]': big }"
    data-test="promo-badge"
  >
    <img src="/images/icons/deals.svg" class="h-4 w-4" alt="promo" />
    <p class="whitespace-nowrap text-xs font-bold leading-4 text-mcd-green">
      {{ displayText }}
    </p>
  </div>
</template>
